
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    title="选择注册角色"
    width="400px"
    @close="close"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item prop="role">
        <el-select
          v-model="form.role"
          placeholder="请您选择注册角色"
          class="select"
          clearable
        >
          <el-option label="企业" value="0"/>
          <el-option label="工作站" value="1"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    selectRoleShow: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        role: ''
      }
    }
  },
  watch: {
    selectRoleShow(v) {
      this.dialogVisible = v
    }
  },
  created() {
    this.dialogVisible = this.selectRoleShow
  },
  methods: {
    close() {
      this.dialogVisible = false
      this.$emit('close')
    },
    handleConfirm() {
      let {role} = this.form
      if (!role) {
        this.$message.warning('请您选择注册角色')
      } else {
        this.$emit('changeRole', role)
        this.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/assist/login/selectRoleDialog.vue